module.exports = __webpack_public_path__ + "static/media/haute16B.1af24951.jpg";